import { useQuery } from '@tanstack/react-query';

import { AITerms } from '@graylog/enterprise-api';

import { defaultOnError } from 'util/conditional/onError';

export type AcceptanceState = {
  accepted: boolean;
  acceptanceDetails: string;
  terms: {
    'version': string;
    'date': string;
    'text': string;
  };
  error?: string;
};

const defaultState: AcceptanceState = {
  accepted: null,
  acceptanceDetails: null,
  terms: null,
};
const getAcceptanceState = (): Promise<AcceptanceState> =>
  AITerms.acceptance().then(
    (state) => ({
      ...state,
      acceptanceDetails: state.acceptance_details,
    }),
    (error) => {
      if (error.status === 409) {
        return defaultState;
      }

      return {
        ...defaultState,
        error: error?.responseMessage ?? error?.message ?? 'Fetching Terms Acceptance state failed for unknown reason.',
      };
    },
  );

const useAITermsAcceptance = (): {
  data: AcceptanceState;
  isLoading: boolean;
  refetch: () => void;
} => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ['investigation-ai-acceptance-by-user'],

    queryFn: () =>
      defaultOnError(
        getAcceptanceState(),
        'Fetching acceptance status failed with status',
        'Could not fetch acceptance status',
      ),

    gcTime: 0,
  });

  return {
    data: data ?? defaultState,
    isLoading,
    refetch,
  };
};

export default useAITermsAcceptance;
